import { z } from 'zod';
// Consumable counting units — vocabulary in CODE (SCHEMA §consumable_types:
// a new word is a code change, never a migration; the audit_logs.action
// precedent). One counting unit per type, fixed instance-wide; CONVERSIONS
// NEVER (ERP territory refused) — pack size lives in the NAME ("Cable ties —
// pack of 100").
//
// Service law: fractional quantities only for the measure words (l · kg · m);
// whole numbers for the count words. Enforced wherever quantities enter
// (import now; the transaction verbs, when they land, ride the same helper).
export const CONSUMABLE_UNITS = ['pcs', 'pack', 'box', 'roll', 'pair', 'l', 'kg', 'm'];
export const ConsumableUnitSchema = z.enum(CONSUMABLE_UNITS);
const FRACTIONAL_UNITS = new Set(['l', 'kg', 'm']);
/** Whether a unit admits fractional quantities (the measure words). */
export function isFractionalUnit(unit) {
    return FRACTIONAL_UNITS.has(unit);
}
/** The quantity law for a unit: fractional only for l/kg/m, else integer. */
export function isQuantityLegal(unit, quantity) {
    return isFractionalUnit(unit) || Number.isInteger(quantity);
}
